<template>
  <div class="section">
    <div class="container">
        <h4>Impressum</h4>
        <card>
            <h6>Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.</h6>

            Ing. Jürgen Punz, MSc<br/>
            Wolfshütte 96<br/>
            A-4903 Manning<br/><br/>

            UID: ATU77757027<br/>
            Unternehmensgegenstand: IT Dienstleistungen<br/><br/>

            <i class="now-ui-icons ui-1_email-85"></i>&nbsp;&nbsp;<a href="mailto:juergen@punz-dev.com">juergen@punz-dev.com</a><br/>
            <i class="now-ui-icons tech_mobile"></i>&nbsp;&nbsp;<a href="tel:+436502157772">+43 (0) 650 215 777 2</a><br/><br/>
        
            Berufsbezeichnung: Softwareentwickler<br/>
            Verleihungsstaat: Österreich<br/>
            Mitglied bei der WKO Oberösterreich<br/><br/>

            <h6>Haftung für Inhalte dieser Website</h6>
            Wir entwickeln die Inhalte dieser Website ständig weiter und bemühen uns korrekte und aktuelle Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Website übernehmen, speziell für jene, die seitens Dritter bereitgestellt wurden. Als Diensteanbieter sind wir nicht verpflichtet, die von ihnen übermittelten oder gespeicherten Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.<br/><br/>

            Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen aufgrund von gerichtlichen oder behördlichen Anordnungen bleiben auch im Falle unserer Nichtverantwortlichkeit davon unberührt.<br/><br/>

            Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte wir Sie uns umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte entfernen können. Sie finden die Kontaktdaten im Impressum.<br/><br/>

            <h6>Haftung für Links auf dieser Website</h6>
            Unsere Website enthält Links zu anderen Websites für deren Inhalt wir nicht verantwortlich sind. Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.<br/><br/>

            Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir Sie uns zu kontaktieren. Sie finden die Kontaktdaten im Impressum.<br/><br/>
        
            <h6>Urheberrechtshinweis</h6>
            Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Bitte fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder verwerten wie zum Beispiel auf anderen Websites erneut veröffentlichen. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.<br/><br/>

            Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.<br/><br/>

            <small>Quelle: Erstellt mit dem <a target="_blank" href="https://www.adsimple.at/impressum-generator/">Impressum Generator</a> von AdSimple</small>
        </card>
    </div>
  </div> 
</template>

<script>
import { Card } from '@/components';

export default {
  name: 'imprint',
  bodyClass: 'main',
  components: {
    Card
  }
}
</script>